import { Box, Card, CardContent, CircularProgress, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { DoorDto } from "./dtos/DoorDto";
import { useCommonDoorScheduleHttp } from "./hooks/useCommonDoorScheduleHttp";


type SelectDoorProps = {

    disabled: boolean;
    onSelectDoor( doorCode : string) : void;
    village?: string;
    width: string;

};


export const SelectDoor: React.FC<SelectDoorProps> = ( props: SelectDoorProps ) => {

    const { disabled, onSelectDoor, village, width } = props;
    
    const [ isLoading, setIsLoading ] = useState< boolean >( false );
    const [ label, setLabel ] = useState< string >( 'Door *' );
    const [ selectedDoor, setSelectedDoor ] = useState< string >( '' );
    const [ doors, setDoors ] = useState< DoorDto[ ] >( [ ] );
    

    const { getDoors } = useCommonDoorScheduleHttp( );


    useEffect( ( ) => {
        
        const fetchDoors = async ( ) => {

            if( !village ){
                
                setSelectedDoor( '' );
                return;
            }

            reset();

            setIsLoading( true );
            const doorDtos = await getDoors( village );
            setIsLoading( false );

            if( doorDtos ) {
                setDoors( doorDtos );
            }

        }; 
        fetchDoors( );

    }, [ village ] );


    useEffect( () => {
    
        if(disabled){
            
            reset();
            
        }

    }, [ disabled ]);
    
    
    const handleDoorChange = ( event: SelectChangeEvent ) => {
    
        const selectedDoor: string = event.target.value;
        
        setSelectedDoor( selectedDoor );
        onSelectDoor( selectedDoor );
        setLabel( 'Door' );

    }


    const reset = () => {

        setSelectedDoor( '' );
        setLabel( 'Door *' );

        onSelectDoor( '' );

    };


    return (

        <>
            {   
                isLoading
                    ?
                <Card variant="outlined" sx = {{ height: '54px', width: width }}>
                
                    <CardContent>
                        <Stack direction="row" sx={{ display: "flex" }}>

                            <Typography >
                                Door *
                            </Typography>

                            <Box sx={{ flexGrow: 1 }} />

                            <CircularProgress size={ 30 } sx={{ color: '#e65400', marginTop: '-3px' }}/>

                        </Stack>
                    </CardContent>

                </Card>
                    :
                <FormControl sx={{ width: width }}>
                    <InputLabel> { label } </InputLabel>
                    <Select
                        disabled={ isLoading || disabled }
                        onChange={ handleDoorChange }
                        value={ selectedDoor }
                        label={ label }>
                            {doors.map( (door) => (
                                <MenuItem value={ door.code } key={ door.code }>{ door.name }</MenuItem>
                            ))}
                    </Select>
                </FormControl>

            }

        </>

    );

};